"use strict";

exports._ = exports._non_iterable_rest = _non_iterable_rest;
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
